import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Client} from "../dto/client";
import {UpdateClientRequest} from "../dto/update-client.request";

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  constructor(private readonly http: HttpClient) {
  }

  getAll() {
    return this.http.get<Client[]>(environment.API_URL + '/api/client/all');
  }

  create(request: UpdateClientRequest) {
    return this.http.post<Client>(
      `${environment.API_URL}/api/client`,
      request
    );
  }

  update(uuid: string, request: UpdateClientRequest) {
    return this.http.patch<Client>(
      `${environment.API_URL}/api/client/${uuid}`,
      request
    );
  }
}
